import { render, staticRenderFns } from "./ProjectItemTestGroupsDialog.vue?vue&type=template&id=f1881aa8&scoped=true&"
import script from "./ProjectItemTestGroupsDialog.vue?vue&type=script&lang=ts&"
export * from "./ProjectItemTestGroupsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectItemTestGroupsDialog.vue?vue&type=style&index=0&id=f1881aa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1881aa8",
  null
  
)

export default component.exports